import React, { Fragment, useState} from "react";
import { Modal as _Modal } from "react-bootstrap";
import Button, {
    BUTTON_TYPE_PRIMARY_PURPLE,
    BUTTON_TYPE_SECONDARY
} from "../ButtonNew/Button";
import styles from "./Modal.module.scss";
import { Tooltip as ReactTooltip } from 'react-tooltip'
import {hasValue} from "../../helpers/helperFunctions";
import { ReactComponent as CloseIcon } from "../../images/svg/closeIcon.svg";

export const MODAL_TOOLTIP_ID = 'modalTooltip';

export const MODAL_SIZE_FULL = 'MODAL_SIZE_FULL';
export const MODAL_SIZE_EXTRA_LARGE = 'MODAL_SIZE_EXTRA_LARGE';
export const MODAL_SIZE_LARGE = 'MODAL_SIZE_LARGE';
export const MODAL_SIZE_MEDIUM = 'MODAL_SIZE_MEDIUM';
export const MODAL_SIZE_MEDIUM_SMALL = 'MODAL_SIZE_MEDIUM_SMALL';
export const MODAL_SIZE_SMALL = 'MODAL_SIZE_SMALL';

const Modal = (props) => {
    const {
        children,
        header,
        headerClassName,
        title,
        text,
        confirmButtonText,
        confirmButtonIcon,
        confirmButtonDisabled,
        onConfirm,
        setShow,
        show,
        exit,
        type = MODAL_SIZE_MEDIUM,
    } = props;

    const [error2, setError2] = useState(false);
    const [error, setError] = useState(false);

    const handleClose = () => setShow(false);

    const dialogClassName = () => {
        switch (type) {
            case MODAL_SIZE_FULL: return styles.modalDialogFull;
            case MODAL_SIZE_EXTRA_LARGE: return styles.modalDialogExtraLarge;
            case MODAL_SIZE_LARGE: return styles.modalDialogLarge;
            case MODAL_SIZE_MEDIUM: return styles.modalDialogMedium;
            case MODAL_SIZE_MEDIUM_SMALL: return styles.modalDialogMediumSmall;
            case MODAL_SIZE_SMALL: return styles.modalDialogSmall;
            default: return styles.modalDialogMedium;
        }
    }

    const getModalClassName = () => {
        if (exit || hasValue(confirmButtonText)) return (styles.modal + ' ' + styles.modalWithFooter);

        return (styles.modal)
    }

    const getModalBodyClassName = () => {
        if (header) {
            if (exit || hasValue(confirmButtonText)) return (styles.modalBodyWithHeaderWithFooter);
        }

        if (exit || hasValue(confirmButtonText)) return (styles.modalBodyWithFooter);

        return (styles.modalBody)
    }

    if(children) {
        return (
            <_Modal
            show={show}
            onHide={() => {setShow(false); setError(false); setError2(false);}}
            className={getModalClassName()}
            dialogClassName={dialogClassName()}
            contentClassName={styles.modalContent}
            centered>
            {header && <_Modal.Header className={styles.modalHeader + ' ' + headerClassName}>
                <span className={styles.modalHeaderTitle}>{header}</span>
                <div className={styles.modalHeaderCloseButtonContainer} onClick={handleClose}>
                    <CloseIcon />
                </div>
            </_Modal.Header>}
            <_Modal.Body className={getModalBodyClassName()}>
                {children}
            </_Modal.Body>
            {(exit || hasValue(confirmButtonText)) && <>
                <div className={styles.modalFooterDivider}/>
                <_Modal.Footer className={styles.modalFooter}>
                    {
                        exit
                        &&
                        <Button
                            text="Close"
                            muteHover
                            buttonType={hasValue(confirmButtonText) ? BUTTON_TYPE_SECONDARY : BUTTON_TYPE_PRIMARY_PURPLE}
                            onClick={handleClose}/>
                    }

                    {hasValue(confirmButtonText) &&
                        <Button

                            text={confirmButtonText}
                            disabled={confirmButtonDisabled}
                            buttonType={BUTTON_TYPE_PRIMARY_PURPLE}
                            Icon={confirmButtonIcon}
                            onClick={onConfirm}/>
                    }
                </_Modal.Footer>
            </>}

                <ReactTooltip id={MODAL_TOOLTIP_ID} effect="solid" place="top" html={true}/>
            </_Modal>
        );
    }
}

export default Modal;